(function () {
    'use strict';

    angular.module('ib-reusable-module', [
        'ib-pmt-required-fields-module',
        'ib-modal-module',
        'ib-pmt-tabs-module',
        'ib-dates-module',
        'ib-iberia-pay-credit-card-number-module',
        'ib-iberia-pay-cvv-number-module'
    ]);
})();
